export default __webpack_public_path__ + "static/16-2e82421fcfeb92d16ccef87acfd23443.png";